import { render, staticRenderFns } from "./UserAssetsTable.vue?vue&type=template&id=3324c3e0&scoped=true"
import script from "./UserAssetsTable.vue?vue&type=script&lang=js"
export * from "./UserAssetsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3324c3e0",
  null
  
)

export default component.exports